import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Edit = ({ show, onClose, selectedId, refresh }) => {
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const [lead_name, setname] = useState('');
  const [mobile_no, setMobileno] = useState('');
  const [email_id, setEmailid] = useState('');
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');
  const [leadId, setLeadID] = useState(null);
  const [datas, setdatas] = useState([]);
  const [area, setArea] = useState(null);
  useEffect(() => {
    const fetchleaddetails = async () => {
      try {
        const response = await axios.get(`${baseURL}/subscriber/profile/${selectedId}`);
        setname(response.data.subscriber_name);
        setMobileno(response.data.mobile_no);
        setEmailid(response.data.email_id);
        setAddress(response.data.address);
        setLeadID(response.data.lead_id);
        setDescription(response.data.description);
        setdatas(response.data);
        setArea(response.data.area);
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };

    fetchleaddetails();
  }, []);

  const [areaOption, setAreaOption] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  
  useEffect(() => {
      const fetchLeadSource = async () => {
          try {
            const response = await axios.get(`${baseURL}/dropdown/area`, {params: {branch_id: branch_id}});
            const formattedsource = response.data.data.map(item => ({
              value: item.sno,
              label: item.area_name,
            }));
            setAreaOption(formattedsource);
          } catch (error) {
              console.error('Error fetching data:', error);
          }
      };

      fetchLeadSource();
  }, []);

  useEffect(() => {
      if (area) {
          const preselected = areaOption.filter(option => option.value === area);
          // console.log(preselected);
          setSelectedArea(preselected);
      }
  }, [area, areaOption]);

  const handleareachange = (selectedOption) => {
      setSelectedArea(selectedOption);
      setArea(selectedOption.value);
  };


  const formatName = (name) => {
      return name.charAt(0).toUpperCase() + name.slice(1);
  };

  // add more content

  const [addresses, setAddressess] = useState([{ id: Date.now(), address: ''}]);
  const [locations, setLocations] = useState([{ id: Date.now(), url: "" },]);

  const handleAddConfig = () => {
    setAddressess([...addresses, { id: Date.now(), address: '', error: '' }]);
  };

  // Handle address change
  const handleAddressChange = (e, id) => {
    const updatedAddresses = addresses.map((config) =>
      config.id === id ? { ...config, address: e.target.value } : config
    );
    setAddressess(updatedAddresses);
  };

  // Handle address deletion
  const handleDeleteConfig = (id) => {
    const updatedAddresses = addresses.filter((config) => config.id !== id);
    setAddressess(updatedAddresses);
  };

  useEffect(() => {
    if (datas?.multiple_address && Array.isArray(datas.multiple_address)) {
      const formatted = datas.multiple_address.map((item, index) => ({
        id: Date.now() + index,
        address: item.address,
      }));
      setAddressess(formatted);
    }
    if (datas?.multiple_location_url && Array.isArray(datas.multiple_location_url)) {
      const formatted = datas.multiple_location_url.map((item, index) => ({
        id: Date.now() + index,
        url: item.url,
      }));
      setLocations(formatted);
    }
  }, [datas]);

  
  const extractLatLngFromUrl = (url) => {
      const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (match) {
          return {
              lat: parseFloat(match[1]),
              lng: parseFloat(match[2]),
          };
      }
      return null;
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      const coords = extractLatLngFromUrl(url);
      if (coords) {
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  };

  const handleLocationChange = (e, id) => {
    const newUrl = e.target.value;
    setLocations((prev) =>
      prev.map((loc) => (loc.id === id ? { ...loc, url: newUrl } : loc))
    );

    // Validate url and set error if invalid and not empty
    if (newUrl && !isValidUrl(newUrl)) {
      setErrors((prev) => ({ ...prev, [id]: "Not a Valid Location URL." }));
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[id];
        return newErrors;
      });
    }
  };

  const handleAddLocation = () => {
    setLocations((prev) => [...prev, { id: Date.now(), url: "" }]);
  };

  const handleDeleteLocation = (id) => {
    setLocations((prev) => prev.filter((loc) => loc.id !== id));
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[id];
      return newErrors;
    });
  };
  
  const [errors, setErrors] = useState({});
  const validate = () => {
    const newErrors = {};
    const regex = /^[A-Za-z\s]+$/;
    if (!lead_name.trim()) {
        newErrors.name = "This Field is Required.";
    } else if (!regex.test(lead_name)) {
        newErrors.name = "Not a Valid Name";
    }

    if (!mobile_no) {
      newErrors.mobile = "This Field is Required.";
    } else if (!/^[6-9]\d{9}$/.test(mobile_no)) {
      newErrors.mobile = "Enter a Valid Number.";
    } else if (mobile_no.length != 10) {
      newErrors.mobile = "Enter a Valid Number.";
    }

    addresses.forEach((config) => {
      if (!config.address) {
        newErrors[config.id] = 'This Field is Required.';
      }
    });

    locations.forEach((loc) => {
      if (!loc.url) {
        newErrors[loc.id] = "This Field is Required.";
      } else if (!isValidUrl(loc.url)) {
        newErrors[loc.id] = "Invalid Location URL";
      }
    });


    return newErrors;
  };
  
  const handleSubmit = (event) => {
      event.preventDefault();

      const validationErrors = validate();
      if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
          return;
      }
      const multiple_address = addresses.map((config) => ({ address: config.address }));
      // console.log(multiple_address);
      // console.log('Submitting payload:', JSON.stringify(multiple_address));

      const multiple_locations = locations.map((loc) => ({ url: loc.url }));
      // console.log('Submitting payload:', JSON.stringify(multiple_locations));


      const postData = { 
        subscriber_name: lead_name,
        mobile_no: mobile_no.toString(),
        email_id: email_id,
        multiple_address: multiple_address,
        address: multiple_address[0]?.address || '',
        multiple_location_url: multiple_locations,
        description: description,
        area: area,
        updated_by: user_id,
      };
      // console.log(postData);
      // Create a new post
      axios.put(`${baseURL}/subscriber/${selectedId}`, postData)
          .then(response => {
              onClose();
              refresh();
              toast.success("Subscriber Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Subscriber Updation Failed");
            });
  };


  return (
    <Modal show={show} size="md">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Update Subscriber</h3>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className='text-white'>×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">Subscriber<span className="required">*</span></label>
              <input type="text" className="form-control" placeholder="Enter Subscribers Name" 
                  maxLength={100}
                  value={lead_name} 
                  onChange={(e) => {
                      const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                      setname(formatName(onlyAlphabets))
                  }}
              />
              {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
            </div>
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">Mobile No<span className="required">*</span></label>
              <input type="text" className="form-control" placeholder="Enter Mobile No" 
                  maxLength={10}
                  value={mobile_no} 
                  onChange={(e) => {
                      const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                      setMobileno(onlyNums)
                  }} 
              />
              {errors.mobile && <div className="text-danger fs-8 mt-1">{errors.mobile}</div>}
            </div>
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">Email ID</label>
              <input type="text" className="form-control" placeholder="Enter Email ID" 
                  maxLength={100}
                  value={email_id} 
                  onChange={(e) => setEmailid(e.target.value)}
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label className="text-black font-w500 fs-7">Area <span className="required">*</span></label>
              <Select
                 value={selectedArea}
                  onChange={handleareachange}
                  options={areaOption}
                placeholder="Select Area"
              />
            </div>
            
            {/* multiple address */}
            <div className="col-lg-12 mb-3">
              <div className="mb-0" style={{ maxHeight: addresses.length > 2 ? '200px' : 'auto', overflowY: addresses.length > 2 ? 'auto' : 'visible', overflowX: 'hidden'}}>
                {addresses.map(config => (
                  <div key={config.id} data-repeater-item>
                    <div className="row">
                      <div className='col-lg-10'>
                        <label className="text-black font-w500 fs-7">Address <span className="required">*</span></label>
                        <textarea rows={8} className="form-control" placeholder="Enter Address" 
                            maxLength={255}
                            value={config.address}
                            onChange={(e) => handleAddressChange(e, config.id)}
                        />
                        {errors[config.id] && (
                          <div className="text-danger fs-8 mt-1">{errors[config.id]}</div>
                        )}
                      </div>

                      <div className="col-lg-1 mb-1 px-1 py-1">
                        {addresses.length > 1 && (
                          <button
                            className="btn btn-danger mt-4 px-2 py-2"
                            onClick={() => handleDeleteConfig(config.id)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Delete"
                          >
                            <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mb-1 mt-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleAddConfig}
                >
                  <span><i className="fa-solid fa-plus fs-6"></i></span>
                  <span className='ms-2 fs-7'>Add Address</span>
                </button>
              </div>
            </div>
              
            {/* multiple location */}
            <div className="col-lg-12 mb-3">
              <div className="mb-0" style={{ maxHeight: locations.length > 2 ? "200px" : "auto",  overflowY: locations.length > 2 ? "auto" : "visible",  overflowX: "hidden",}}>
                {locations.map((loc) => (
                  <div key={loc.id} data-repeater-item>
                    <div className="row align-items-center">
                      <div className="col-lg-10">
                        <label className="text-black font-w500 fs-7">
                          Location URL <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Location URL"
                          value={loc.url}
                          onChange={(e) => handleLocationChange(e, loc.id)}
                        />
                        {errors[loc.id] && (
                          <div className="text-danger fs-8 mt-1">{errors[loc.id]}</div>
                        )}
                      </div>

                      <div className="col-lg-1 mb-1 px-1 py-1">
                        {locations.length > 1 && (
                          <button
                            className="btn btn-danger mt-4 px-2 py-2"
                            onClick={() => handleDeleteLocation(loc.id)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Delete"
                            type="button"
                          >
                            <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mb-1 mt-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleAddLocation}
                  type="button"
                >
                  <span>
                    <i className="fa-solid fa-plus fs-6"></i>
                  </span>
                  <span className="ms-2 fs-7">Add Location</span>
                </button>
              </div>
            </div>
            
            {/* description */}
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea className="form-control h-auto" placeholder="Enter Description" 
                  maxLength={255}
                  value={description} 
                  onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Subscriber<i className="fas fa-angle-double-right ms-2"></i></Link>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Edit;
